import { helpConstants } from 'Constants/help.constants';
import Request from 'Services/request';
import { alterQueryRequest, findCurrentPageRequest, queryParser } from 'Helpers/urlform'
import { toast as toastr } from 'react-toastify';
import { handleApiError } from 'Helpers/index';

const requestHelp = help => ({
    type:  helpConstants.HELP_REQUEST,
    help
})

const successHelp = helpObj => ({
    type:  helpConstants.HELP_GET_SUCCESS,
    help: helpObj.data,
    totalRecords: helpObj.count,
    currentPage: helpObj.currentPage
})

const failureHelp = error => ({
    type:  helpConstants.HELP_FAILURE,
    error
})

const requesUpdatetHelp = help => ({
    type:  helpConstants.HELP_FORM_REQUEST,
    help
})

const successUpdateHelp = helpObj => ({
    type: helpConstants.UPDATE_HELP_SUCCESS,
    help: helpObj
})

const failureSaveHelp = error => ({
    type: helpConstants.HELP_SAVE_FORM_FAILURE,
    error
})

function fetchHelp(SearchArray) {
    let url = '/feedback';
    if (SearchArray && SearchArray.length > 0) {
        url = queryParser(url, SearchArray);
    }
    const currentPage = findCurrentPageRequest(SearchArray);
    return async (dispatch) => {
        dispatch(requestHelp({}));
        await Request.get(url, {})
            .then((response) => {
                const { data, count } = response;
                dispatch(successHelp({ data, count, currentPage }));
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureHelp(error.toString()));
                }
            });
    };
}

function updateHelp(helpObj, SearchArray) {
    const { id, description, ...rest } = helpObj
    return (dispatch) => {
        dispatch(requesUpdatetHelp({}));
        Request.update(`/feedback/${ id }`,
            { description })
            .then((response) => {
                const { status, message } = response;
                const displayMessage = (status === 200) ? 'Help reply sent Successfully' : 'Error '+ status;
                dispatch(successUpdateHelp(helpObj));
                dispatch(fetchHelp(SearchArray))
                toastr.dismiss();
                toastr.success(displayMessage);
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureSaveHelp(error.toString()));
                }
            });
    };
}

function deleteHelp(id, SearchArray, remainningRecords, currentPage) {
    const updateSearchArray = alterQueryRequest(SearchArray, remainningRecords, currentPage);
    return (dispatch) => {
        dispatch(requestHelp({}));
        Request.remove(`/feedback?id=${ id }`,
            {})
            .then((response) => {
                const { message } = response;
                dispatch(fetchHelp(updateSearchArray));
                toastr.dismiss();
                toastr.success(message);
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureHelp(error.toString()));
                }
            });
    }
}

const requestHelpExportData = exportData => ({
    type: helpConstants.EXPORT_HELP_REQUEST,
    exportData
})

const successHelpExportData = exportDataObj => ({
    type: helpConstants.EXPORT_HELP_SUCCESS,
    exportData: exportDataObj.data,
    totalRecords: exportDataObj.count
})

const failureHelpExportData = error => ({
    type: helpConstants.EXPORT_HELP_FAILURE,
    error
})

function exportHelp(SearchArray) {
    let url = '/feedback';
    if (SearchArray && SearchArray.length > 0) {
        url = queryParser(url, SearchArray);
    }
    const exportUrl = SearchArray && SearchArray.length > 0 ? `&exportType=true` : `?exportType=true`;
    
    url = `${ url }${ exportUrl }`;
    return async (dispatch) => {
        dispatch(requestHelpExportData({}));
        await Request.get(url, {})
            .then(response => {
                const { data = [], count = 10 } = response;
                data.forEach(function(res){ 
                    res[ 'First Name' ] = res.firstName; 
                    res[ 'Last Name' ] = res.lastName; 
                    res[ 'Email' ] = res.email; 
                    res[ 'Device Platform' ] = res.devicePlatform; 
                    res[ 'Device Model' ] = res.deviceModel; 
                    res[ 'App Version' ] = res.appVersion; 
                    res[ 'Description' ] = res.description; 
                    res[ 'Status' ] = res.status === 1 ? 'Enable' : 'Disable'; 
                    delete res.id; delete res.firstName; delete res.lastName;
                    delete res.email; delete res.devicePlatform; delete res.deviceModel;
                    delete res.appVersion; delete res.description; delete res.status; delete res.image;
                });
                dispatch(successHelpExportData({ data, count }));
            })
            .catch((error) => {
                if(error) {
                    handleApiError(error);
                    dispatch(failureHelpExportData(error.toString()));
                }
            });
    };
}

export const HelpAction = {
    fetchHelp,
    updateHelp,
    deleteHelp,
    exportHelp,
}